import script from "./PopupEtichete.vue?vue&type=script&setup=true&lang=ts"
export * from "./PopupEtichete.vue?vue&type=script&setup=true&lang=ts"

import "./PopupEtichete.vue?vue&type=style&index=0&id=cfcb77c6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cfcb77c6"]])

export default __exports__